import { useQuery } from '@tanstack/react-query';
import { fetchDocumentAllowedExtensionsList } from '@views/screens/common/data-provider/document-allowed-extension-list';
import type { GetDocumentAllowedExtensionsListRequestParams } from '@views/screens/common/data-provider/document-allowed-extension-list/api';

export const useGetDocumentAllowedExtensionsList = (params: GetDocumentAllowedExtensionsListRequestParams) => {
  return useQuery({
    queryKey: ['document-allowed-extensions-list', params],
    queryFn: () => fetchDocumentAllowedExtensionsList(params),
    staleTime: 1000 * 5, // 5 seconds (to avoid multiple calls)
    enabled: !!params.moduleId,
  });
};
